import url from '../../../../url.js';
export default {
  data() {
    return {
        title: 'Frequently Asked Questions',
        Api: url.API_URL,
        dataFaq: [],
        activeIndex: null,
    };
  },

  async mounted() {
    await this.fetchFaq();
  },

  methods: {
    async fetchFaq() {
      try {
        const response = await fetch(`${this.Api}m145_faqs/id/2`);
        const data = await response.json();
        this.dataFaq = data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },

    toggleFaq(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
  },
};
